import { useEffect, useState } from "react";
import { http } from "@/lib/api";

let _cached = null;
let _inflight = null;

/**
 * Lightweight public settings hook. Caches once per session.
 */
export function useSiteSettings() {
  const [settings, setSettings] = useState(_cached);
  useEffect(() => {
    if (_cached) return;
    if (!_inflight) {
      _inflight = http.get("/public/settings").then(({ data }) => {
        _cached = data;
        return data;
      }).catch(() => ({}));
    }
    _inflight.then((d) => setSettings(d));
  }, []);
  return settings || {};
}

/** Allows admin UI to invalidate the cache after toggling a setting. */
export function clearSiteSettingsCache() {
  _cached = null;
  _inflight = null;
}
